import React, { useEffect, useState } from 'react';
import { Tabs, TreeSelect, Empty, Spin } from 'antd';

/**
 * 平台组件类目选择：服务/实物 两级树多选，存 cateIds:number[]
 * 数据源 /api/sys-category/tree?goodsType=NORMAL|GOODS（平台共享 sys_category 树）
 */
export default (props) => {
    const { value = [], onChange } = props;
    const [treeData, setTreeData] = useState({ NORMAL: [], GOODS: [] });
    const [loading, setLoading] = useState(true);
    const [activeKey, setActiveKey] = useState('NORMAL');

    const fetchTree = async (goodsType) => {
        try {
            const res = await fetch(`/api/sys-category/tree?goodsType=${goodsType}`);
            const result = await res.json();
            return Array.isArray(result?.data) ? result.data : [];
        } catch (e) {
            return [];
        }
    };

    useEffect(() => {
        let unmounted = false;
        Promise.all([fetchTree('NORMAL'), fetchTree('GOODS')]).then(([normal, goods]) => {
            if (unmounted) return;
            setTreeData({ NORMAL: normal, GOODS: goods });
            setLoading(false);
        });
        return () => { unmounted = true; };
    }, []);

    const arr = Array.isArray(value) ? value.map(Number) : [];

    return (
        <div className='comp-form-customer-field'>
            <Tabs
                size="small"
                activeKey={activeKey}
                onChange={setActiveKey}
                items={[
                    { key: 'NORMAL', label: '服务', children: renderTree('NORMAL') },
                    { key: 'GOODS', label: '实物', children: renderTree('GOODS') },
                ]}
            />
        </div>
    );

    function renderTree(goodsType) {
        const tree = treeData[goodsType] || [];
        if (loading) return <Spin size="small" style={{ display: 'block', margin: '8px auto' }} />;
        if (tree.length === 0) return <Empty description="暂无类目" image={Empty.PRESENTED_IMAGE_SIMPLE} />;
        return (
            <TreeSelect
                style={{ width: '100%' }}
                value={arr}
                onChange={onChange}
                allowClear
                multiple
                treeCheckable
                showCheckedStrategy={TreeSelect.SHOW_ALL}
                treeDefaultExpandAll
                maxTagCount="responsive"
                treeData={tree}
                placeholder="请选择类目（不选=全平台）"
                treeNodeFilterProp="label"
            />
        );
    }
};
